var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "icon-badge" }, [
    _vm.isBadgeVisible
      ? _c(
          "div",
          {
            staticClass: "inbox-popup",
            class: [_vm.direction, { "no-opacity": _vm.popupClassOpacity }],
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.openInbox.apply(null, arguments)
              },
            },
          },
          [
            !_vm.isInline
              ? _c("img", {
                  staticClass: "inbox-popup-icon",
                  attrs: {
                    src: "https://media.socialdeal.nl/img/inbox-message.svg",
                    width: "16",
                    height: "16",
                    alt: "",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("span", { staticClass: "inbox-popup-text" }, [
              _vm._v(_vm._s(this.unreadMessageCount.count)),
            ]),
            _vm._v(" "),
            !_vm.isInline
              ? _c("span", { staticClass: "inbox-popup-attribute" })
              : _vm._e(),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.isInline && _vm.isDotVisible
      ? _c("div", {
          staticClass: "inbox-dot",
          class: [_vm.direction, { opacity: _vm.dotClassOpacity }],
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }